import React from "react";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

const AppLoader = ({ open = false, message = "Loading..." }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 20000, // higher than header & sweetalert
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.4)", // smooth overlay
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <CircularProgress size={60} thickness={4} color="inherit" />
        <Typography variant="h6" fontWeight={500}>
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default AppLoader;